<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ contractTypeTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ contractTypeSubtitle | translate }}
            </p>
        </div>

        <form class="form" [formGroup]="formGroup">
            <!-- workContractType -->
            <div class="form-row">
                <p-selectButton
                    id="workContractType"
                    formControlName="workContractType"
                    class="p-selectbutton"
                    [options]="workContractTypeOptions"
                    optionLabel="label"
                    optionValue="code"
                    (onOptionClick)="onChangeWorkContractType($event)"
                ></p-selectButton>
            </div>

            <div class="more-options">
                <button *ngIf="!showMoreWorkContractType" id="more-options" ripple="true" class="more-options" type="button" (click)="onClickWorkContractType(true)">
                    <span class="more-options">{{ moreOptions | translate }}</span>
                </button>

                <button *ngIf="showMoreWorkContractType" id="less-options" ripple="true" class="more-options" type="button" (click)="onClickWorkContractType(false)">
                    <span class="more-options">{{ lessOptions | translate }}</span>
                </button>
            </div>

            <!----------------------- >
            <     Stable work         >
            <------------------------->
            <div *ngIf="isStableWorkContractType && showForm" class="form-row">
                <!-- stableWorkingStartDate -->
                <div class="form-field">
                    <div class="form-calendar">
                        <p-calendar
                            id="stableWorkingStartDate"
                            class="calendar"
                            formControlName="stableWorkingStartDate"
							view="month"
                            dateFormat="mm/yy"
                            [showIcon]="true"
                            [showOnFocus]="false"
                            ngDefaultControl
                            selectionMode="single"
                            inputId="buttondisplay"
                            placeholder="{{ temporaryWorkingStartDateLabel | translate }}"
                            (onSelect)="onChangeDate($event)"
                            (onClear)="onChangeDate($event)"
                            (onInput)="onChangeDate($event)"
                            (onClose)="onChangeDate($event)"
                        />
                        <!--
                        <label class="calendar-label" for="stableWorkingStartDate">{{ temporaryWorkingStartDateLabel | translate }}</label>
                        -->
                    </div>
                </div>
            </div>

            <!----------------------- >
            <     temporary work      >
            <------------------------->
            <div *ngIf="!isStableWorkContractType && showForm" class="form-row">
                <!--temporaryWorkingStartDate-->
                <div class="form-field">
                    <p-calendar
                        id="temporaryWorkingStartDate"
                        class="temporary-working-start-date"
                        formControlName="temporaryWorkingStartDate"
                        view="month"
                        dateFormat="mm/yy"
                        [showIcon]="true"
                        [showOnFocus]="false"
                        ngDefaultControl
                        selectionMode="single"
                        inputId="buttondisplay"
                        placeholder="{{ temporaryWorkingStartDateLabel | translate }}"
                        (onSelect)="onChangeDate($event)"
                        (onClear)="onChangeDate($event)"
                        (onInput)="onChangeDate($event)"
                        (onClose)="onChangeDate($event)"
                    />
                </div>

                <!--temporaryWorkingEndDate-->
                <div class="form-field">
                    <p-calendar
                        id="temporaryWorkingEndDate"
                        class="temporary-working-end-date"
                        formControlName="temporaryWorkingEndDate"
                        view="month"
                        dateFormat="mm/yy"
                        [showIcon]="true"
                        [showOnFocus]="false"
                        ngDefaultControl
                        selectionMode="single"
                        inputId="buttondisplay"
                        placeholder="{{ temporaryWorkingEndDateLabel | translate }}"
                        (onSelect)="onChangeDate($event)"
                        (onClear)="onChangeDate($event)"
                        (onInput)="onChangeDate($event)"
                        (onClose)="onChangeDate($event)"
                    />
                </div>
            </div>

            <!-------------------------------- >
            <     stable / temporary work      >
            <---------------------------------->

            <div *ngIf="showForm" class="form-row">
                <div class="form-input-row">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="monthlyNetIncome"
                            id="monthlyNetIncome"
                            name="monthlyNetIncome"
                            (keyup)="onChangeMonthlyNetIncome($event)"
                        />
                        <label class="input-label" for="monthlyNetIncome">{{ monthlyNetIncomeLabel | translate }}</label>

                        <div *ngIf="this.formGroup.controls.monthlyNetIncome.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>

<!--

    <form class="form" [formGroup]="formGroup">

        ----------------------- >
        <     Stable work         >
        <------------------------

        <div *ngIf="isStableWorkContractType && showForm" class="not-working">
            <div>
                <p-calendar
                    [style]="{ width: '100%' }"
                    id="stableWorkingStartDate"
                    class="stable-working-start-date"
                    formControlName="stableWorkingStartDate"
                    dateFormat="dd/mm/yy"
                    [showIcon]="true"
                    [showOnFocus]="false"
                    ngDefaultControl
                    selectionMode="single"
                    inputId="buttondisplay"
                    placeholder="{{ temporaryWorkingStartDateLabel | translate }}"
                    (onSelect)="onChangeDate($event)"
                    (onClear)="onChangeDate($event)"
                    (onInput)="onChangeDate($event)"
                    (onClose)="onChangeDate($event)"
                />
            </div>
            <p></p>
            <div class="form-floating form-floating-group flex-grow-1">
                <input
                    type="number"
                    class="textarea form-control"
                    formControlName="monthlyNetIncome"
                    id="monthlyNetIncome"
                    placeholder=""
                    (keyup)="onChangeMonthlyNetIncome($event)"
                />
                <label for="monthlyNetIncome">{{ monthlyNetIncomeLabel | translate }}</label>
            </div>
        </div>

        ---------------------- >
        <     temporary work      >
        <-------------------------
        <div *ngIf="!isStableWorkContractType && showForm" class="not-working">
            <div class="temporary-dates">
                <div class="start">
                    <p-calendar
                        id="temporaryWorkingStartDate"
                        class="temporary-working-start-date"
                        formControlName="temporaryWorkingStartDate"
                        view="month"
                        dateFormat="mm/yy"
                        [showIcon]="true"
                        [showOnFocus]="false"
                        ngDefaultControl
                        selectionMode="single"
                        inputId="buttondisplay"
                        placeholder="{{ temporaryWorkingStartDateLabel | translate }}"
                        (onSelect)="onChangeDate($event)"
                        (onClear)="onChangeDate($event)"
                        (onInput)="onChangeDate($event)"
                        (onClose)="onChangeDate($event)"
                    />
                </div>

                <div class="end">
                    <p-calendar
                        id="temporaryWorkingEndDate"
                        class="temporary-working-end-date"
                        formControlName="temporaryWorkingEndDate"
                        dateFormat="mm/yy"
                        [showIcon]="true"
                        [showOnFocus]="false"
                        ngDefaultControl
                        selectionMode="single"
                        inputId="buttondisplay"
                        placeholder="{{ temporaryWorkingStartDateLabel | translate }}"
                        (onSelect)="onChangeDate($event)"
                        (onClear)="onChangeDate($event)"
                        (onInput)="onChangeDate($event)"
                        (onClose)="onChangeDate($event)"
                    />
                </div>
            </div>
            <p></p>
            --monthlyNetIncome--
            <div class="form-floating form-floating-group flex-grow-1">
                <input
                    type="number"
                    class="textarea form-control"
                    formControlName="monthlyNetIncome"
                    id="monthlyNetIncome"
                    name="monthlyNetIncome"
                    placeholder=""
                    (keyup)="onChangeMonthlyNetIncome($event)"
                />
                <label for="monthlyNetIncome">{{ monthlyNetIncomeLabel | translate }}</label>
            </div>

            <p></p>
        </div>

    </form>
 -->
